import Vue from 'vue';

import './hub-settings';
import './outlet-central-settings';

Vue.component('card-index', () =>
    import(/* webpackChunkName: 'setting' */ './card/index.vue'),
);

Vue.component('ewallet-index', () =>
    import(/* webpackChunkName: 'setting' */ './ewallet/index.vue'),
);

Vue.component('subsidy-index', () =>
    import(/* webpackChunkName: 'setting' */ './subsidy/index.vue'),
);

Vue.component('vuetable-discount', () =>
    import(/* webpackChunkName: 'setting' */ './discount/datatable.vue'),
);

Vue.component('settings-payment-index', () =>
    import(/* webpackChunkName: 'setting' */ './payment/settings-payment-index.vue'),
);

Vue.component('franchise-settings', () =>
    import(/* webpackChunkName: 'setting' */ './settings.vue'),
);

Vue.component('preset-reason-datatable', () =>
    import(/* webpackChunkName: 'setting' */ './presetreason/presetReasonDatatable.vue'),
);
